import qs from 'query-string'
import { getAccessToken } from './account'

export function parseQueryString () {
  const search = window.location.search

  return qs.parse(search)
}

export function parseJSON (response) {
  return response.json()
}

export function buildQueryString () {
  const { account_id, access_token, refresh_token, audience, expires_in } = parseQueryString()

  return `account_id=${account_id}&access_token=${access_token}&refresh_token=${refresh_token}&audience=${audience}&expires_in=${expires_in}`
}

export function checkStatus (response) {
  if (response.status >= 200 && response.status < 300) {
    return response
  } else {
    const error = new Error(response.statusText)

    error.response = response
    throw error
  }
}

export function createMetaArray (data) {
  return Object.keys(data).map(key => {
    data[key].id = key
    return data[key]
  }).sort((a, b) => a.dts - b.dts)
}

export function metaToTimeline (editData) {
  let timelineData = []
  let currentCut = null
  const meta = createMetaArray(editData)

  for (let item of meta) {
    if (item.meta.action === 'cut-start' && currentCut === null) {
      currentCut = {
        cutStartId: item.id,
        start: new Date(item.dts),
        type: 'range',
        group: 1,
        editable: {
          updateTime: true,
          updateGroup: false,
          remove: true
        }
      }
    } else if (item.meta.action === 'cut-stop' && currentCut !== null) {
      currentCut.end = new Date(item.dts)
      currentCut.cutStopId = item.id
      timelineData.push(currentCut)
      currentCut = null
    }
  }

  return timelineData
}

export function getFileExtension (file = '') {
  const list = file.split('.')

  if (list.length < 2) throw new Error('Can\'t get extension')
  return list.pop()
}

export const isInDefaultStore = (url = '') => url.includes(process.env.MEDIA_STORE_HOST)

export async function getSourceUrl (url) {
  let sourceUrl = url

  if (isInDefaultStore(sourceUrl)) {
    const token = await getAccessToken()

    sourceUrl += `?access_token=${token}`
  }

  return sourceUrl
}

export const getUpdateAddr = (host, audience, id) => `${host}/api/v1/audiences/${audience}/tasks/${id}`

export const getFilePath = (host, origin, set, key) => `${host}/api/v1/backends/${process.env.MEDIA_STORE_HLS_BACKEND}/buckets/${origin}/sets/${set}/objects/${key}`

export const getContentFilePath = (set, key) => getFilePath(process.env.MEDIA_STORE_HOST, process.env.MEDIA_STORE_CONTENT_BUCKET, set, key)

export const getSourceFilePath = (id, host, origin, enforceScheme = false) => {
  return (enforceScheme && process.env.MEDIA_STORE_SCHEME.includes('s3'))
    ? `${process.env.MEDIA_STORE_SCHEME}://${origin}/${id}.source.mp4`
    : `${host}/api/v1/backends/${process.env.MEDIA_STORE_HLS_BACKEND}/buckets/${origin}/sets/${id}/objects/source.mp4`
}

export const getEventsFilePath = (id, host, origin, enforceScheme = false) => {
  return (enforceScheme && process.env.MEDIA_STORE_SCHEME.includes('s3'))
    ? `${process.env.MEDIA_STORE_SCHEME}://${origin}/${id}.events.json`
    : `${host}/api/v1/backends/${process.env.MEDIA_STORE_HLS_BACKEND}/buckets/${origin}/sets/${id}/objects/events.json`
}

export const getEventsFileFromEnv = (env = {}) => {
  return id => getEventsFilePath(id, env.host, env.bucket)
}

export const getSourceFileFromEnv = (env = {}) => {
  return id => getSourceFilePath(id, env.host, env.bucket)
}

export const getEnforcedEventsFileFromEnv = (env = {}) => {
  return id => getEventsFilePath(id, env.host, env.bucket, true)
}

export const getEnforcedSourceFileFromEnv = (env = {}) => {
  return id => getSourceFilePath(id, env.host, env.bucket, true)
}

export function isChaptersMode () {
  const { mode } = parseQueryString()

  return mode === 'chapters'
}



// WEBPACK FOOTER //
// ./src/utils/functions.js